import { render, staticRenderFns } from "./pipe-news.vue?vue&type=template&id=a9b169ac&scoped=true"
import script from "./pipe-news.vue?vue&type=script&lang=js"
export * from "./pipe-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b169ac",
  null
  
)

export default component.exports